"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=t=>["string","number"].includes(typeof t)?t:t instanceof Array?t.map(e).join(""):"object"==typeof t&&t?t.type&&t.type.displayName&&t.type.displayName.includes("Tooltip")?"":t.props.children||"function"!=typeof t.type?e(t.props.children):e(t.type.prototype&&t.type.prototype.render?"StyledComponent"!==t.type.name?p(t):"":t.type(t.props).props.children):void 0,p=e=>new e.type(e.props).render();exports.default=e;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/JavaScriptHelperFunctions/getNodeText.js
// module id = 895
// module chunks = 0